import React from 'react'
import PropTypes from 'prop-types'
import { IoArrowBackOutline } from 'react-icons/io5'
import { FiPlusSquare, FiThumbsUp } from 'react-icons/fi'
import { MdMenu, MdClose, MdLinkedCamera } from 'react-icons/md'
import { FaRegComment } from 'react-icons/fa'

function CommonIconButton({
  className,
  iconButtonType,
  width = 30,
  height = 30,
  color = '#FFA34B',
  backgroundColor = '#FFFFFF',
  onClick,
  ...props
}) {
  const iconStyle = {
    width,
    height,
    color,
    backgroundColor,
  }
  const handleClick = () => {
    onClick()
  }
  return (
    <>
      {iconButtonType === 'back' ? (
        <IoArrowBackOutline
          className={className}
          style={{ ...props.style, ...iconStyle }}
          onClick={handleClick}
        />
      ) : null}
      {iconButtonType === 'plus' ? (
        <FiPlusSquare
          className={className}
          style={{ ...props.style, ...iconStyle }}
          onClick={handleClick}
        />
      ) : null}
      {iconButtonType === 'thumb' ? (
        <FiThumbsUp
          className={className}
          style={{ ...props.style, ...iconStyle }}
          onClick={handleClick}
        />
      ) : null}
      {iconButtonType === 'menu' ? (
        <MdMenu
          className={className}
          style={{ ...props.style, ...iconStyle }}
          onClick={handleClick}
        />
      ) : null}
      {iconButtonType === 'comment' ? (
        <FaRegComment
          className={className}
          style={{ ...props.style, ...iconStyle }}
          onClick={handleClick}
        />
      ) : null}
      {iconButtonType === 'close' ? (
        <MdClose
          className={className}
          style={{ ...props.style, ...iconStyle }}
          onClick={handleClick}
        />
      ) : null}
      {iconButtonType === 'camera' ? (
        <MdLinkedCamera
          className={className}
          style={{ ...props.style, ...iconStyle }}
          onClick={handleClick}
        />
      ) : null}
    </>
  )
}

CommonIconButton.propTypes = {
  className: PropTypes.string,
  iconButtonType: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
}

export default CommonIconButton
